import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { checkPhone } from '@/utils/tools/index';
import behaviorTest from '@/utils/behaviorTest';
import { verifyCodeByForgetpassword, ajaxValidateVerifyCode } from '@/api/login';
export default {
  props: {
    callback: {
      type: Function,
      require: true,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      phone: '',
      checkPhone: '',
      captcha: '',
      getCaptchaTime: '',
      captchaActive: false,
      buttonActive: false
    };
  },
  computed: {
    isButtonActive: function isButtonActive() {
      if (this.buttonActive) {
        return '_active';
      } else {
        return '';
      }
    },
    TestPhone: function TestPhone() {
      if (this.testPhoneNumber(false)) {
        return true;
      }

      return false;
    },
    captchaCanClick: function captchaCanClick() {
      if (this.captchaActive) {
        return '_active';
      } else {
        return '';
      }
    },
    TestConfirm: function TestConfirm() {
      if (this.testPhoneNumber(false) && this.captcha.length > 0) {
        return true;
      }

      return false;
    }
  },
  watch: {
    // phone(newValue) {
    //   // 监听电话号码
    //   if (newValue.length >= 13) {
    //     newValue = newValue.substr(0, 13)
    //   }
    //   this.phone = newValue
    //     .replace(/\D/g, '')
    //     .replace(/\s/g, '')
    //     .replace(/(\d{3})(\d{0,4})(\d{0,4})/, '$1 $2 $3')
    //     .trim()
    //   this.checkPhone = this.phone.replace(/\s/g, '')
    // },
    TestPhone: function TestPhone(value) {
      this.captchaActive = value;
    },
    TestConfirm: function TestConfirm(value) {
      this.buttonActive = value;
    }
  },
  methods: {
    // 处理手机号334分割
    phoneInput: function phoneInput(newValue) {
      var _this = this;

      // 获取input的dom对象，这里因为用的是element ui的input，所以需要这样拿到
      var input = this.$refs.phoneRef.$el.getElementsByTagName('input')[0]; // 获取当前光标的位置

      var cursorIndex = input.selectionStart; // 字符串中光标之前“ ”的个数

      var lineNumOfCursorLeft = (newValue.slice(0, cursorIndex).match(/\s+/g) || []).length; // 去除格式不对的字符并重新插入“ ”的字符串

      var newPhone = newValue.replace(/\s+/g, '').replace(/\D+/g, '').replace(/(\d{3})(\d{0,4})(\d{0,4})/g, '$1 $2 $3').trim(); // 改后字符串中原光标之前“ ”的个数

      var newLineNumOfCursorLeft = (newPhone.slice(0, cursorIndex).match(/\s+/g) || []).length; // 光标在改后字符串中应在的位置

      var newCursorIndex = cursorIndex + newLineNumOfCursorLeft - lineNumOfCursorLeft; // 赋新值，nextTick保证-不能手动输入或删除，只能按照规则自动填入

      this.$nextTick(function () {
        _this.phone = newPhone; // 修正光标位置，nextTick保证在渲染新值后定位光标

        _this.$nextTick(function () {
          // selectionStart、selectionEnd分别代表选择一段文本时的开头和结尾位置
          input.selectionStart = newCursorIndex;
          input.selectionEnd = newCursorIndex;
        });
      });
      this.checkPhone = this.phone.replace(/\s/g, '');
    },
    confirm: function confirm() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$ajaxValidateVe, status;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return ajaxValidateVerifyCode({
                  mobile: _this2.checkPhone,
                  verifyCode: _this2.captcha
                });

              case 2:
                _yield$ajaxValidateVe = _context.sent;
                status = _yield$ajaxValidateVe.status;

                if (status === 1) {
                  _this2.callback({
                    mobile: _this2.checkPhone,
                    verifyCode: _this2.captcha
                  });

                  _this2.$attrs.close();
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getCaptcha: function getCaptcha() {
      if (!this.captchaActive) return;
      if (!this.testPhoneNumber(true)) return;
      var VUE_APP_TARGET = process.env.VUE_APP_TARGET;
      var IS_ONLINE = ['online', 'pre'].includes(VUE_APP_TARGET);
      var config = {
        app_id: 'xdf-edu',
        isTest: !IS_ONLINE,
        area: '.forget-passwod',
        next_width: '280px'
      };
      behaviorTest(config, this.slideSuccess, this.slideError);
    },
    slideSuccess: function slideSuccess(mmvToken) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, _yield$verifyCodeByFo, status;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.$refs.captchaRef.focus(); // 调用接口获取验证码


                params = {
                  mobile: _this3.checkPhone
                };
                _context2.next = 4;
                return verifyCodeByForgetpassword(params, mmvToken);

              case 4:
                _yield$verifyCodeByFo = _context2.sent;
                status = _yield$verifyCodeByFo.status;

                if (status === 1) {
                  _this3.countDown();
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    slideError: function slideError(e) {
      console.log(e, 'error'); // 错误

      this.$message.warning('错误，请重新获取验证码');
    },
    testPhoneNumber: function testPhoneNumber(showMessage) {
      if (!this.checkPhone) {
        showMessage && this.$message.warning('请输入手机号');
        return false;
      }

      if (!checkPhone(this.checkPhone)) {
        showMessage && this.$message.warning('手机号码有误，请重填');
        return false;
      }

      return true;
    },
    countDown: function countDown() {
      var _this4 = this;

      this.getCaptchaTime = 60;
      var timeClock = setInterval(function () {
        _this4.getCaptchaTime--;

        if (_this4.getCaptchaTime === 0) {
          clearInterval(timeClock);
          _this4.getCaptchaTime = '';
        }
      }, 1000);
    }
  }
};